@if (data$ | async; as data) {
  <app-alerts />

  <app-admin-order-shipping-address-form
    [data]="data"
    [shipmentId]="shipmentId()"
    [orderId]="orderId()"
    [pending]="pending()"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
